import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { MunicipalityRecord } from '../entities/records';
import * as selectors from '../entities/Municipality/selectors';

function mapStateToProps(state, { municipalitiesIds }) {
  return {
    municipalities: selectors.municipalitiesByIds(state, municipalitiesIds),
  };
}

export default compose(
  setPropTypes({
    municipalitiesIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    municipalities: PropTypes.arrayOf(PropTypes.instanceOf(MunicipalityRecord)),
  }),
)(mapStateToProps);
